import { render, staticRenderFns } from "./CustomModule.vue?vue&type=template&id=16669ede&scoped=true&"
import script from "./CustomModule.vue?vue&type=script&lang=js&"
export * from "./CustomModule.vue?vue&type=script&lang=js&"
import style0 from "./CustomModule.vue?vue&type=style&index=0&id=16669ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16669ede",
  null
  
)

export default component.exports